/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClipboardAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 2h10v2h4v10h-2V6h-2v2H6V6H4v14h10v2H2V4h4zm2 2v2h6V4zm10 14v-2h2v2h2v2h-2v2h-2v-2h-2v-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgClipboardAdd as ClipboardAdd };
